// Tracks which project is currently running in the IDE preview
// This scopes the chat history and agent to that project

let activeProject: string | null = null
const listeners: Array<(project: string | null) => void> = []

export function getActiveProject(): string | null { return activeProject }

export function setActiveProject(project: string | null) {
  activeProject = project
  listeners.forEach(l => l(project))
  // Dispatch event for components that need to react
  window.dispatchEvent(new CustomEvent('pulse:active-project-changed', { detail: { project } }))
}

export function onActiveProjectChange(fn: (project: string | null) => void) {
  listeners.push(fn)
  return () => { const i = listeners.indexOf(fn); if (i >= 0) listeners.splice(i, 1) }
}
